import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "px-4 px-sm-0" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bollettini, (item, index) => {
        return (_openBlock(), _createBlock(_component_v_expansion_panels, { class: "mb-7" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_expansion_panel, {
              elevation: "0",
              class: "rounded-lg"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, { class: "justify-start align-start align-sm-center flex-column flex-sm-row" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "w-auto ma-0 py-1 py-sm-4 px-1 px-sm-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_chip, {
                          variant: "outlined",
                          class: _normalizeClass(["w-auto px-3 py-1 text-indigo-darken-1 border-indigo", [ index === 0 ? 'bg-blue-lighten-4' : 'bg-white']])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              icon: "mdi-calendar-range-outline",
                              class: "mr-2"
                            }),
                            _createVNode(_component_v_container, { class: "pa-0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.data), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_container, { class: "w-auto ma-0 text-subtitle-1 py-1 py-sm-4 px-1 px-sm-4" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('home.bollettini.title')) + " " + _toDisplayString(_ctx.$t(`home.bollettini.dayByIndex.${ _ctx.getDayIndex(item.data) }`)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_container, { class: "w-auto ma-0 text-body-2 py-1 py-sm-4 px-1 px-sm-4" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('home.bollettini.lastUpdate')) + " " + _toDisplayString(item.testo[0].last_update != '' ? _ctx.getLastUpdate(item.testo[0].last_update) : '-'), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_expansion_panel_text, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.testo, (testo) => {
                      return (_openBlock(), _createBlock(_component_v_container, {
                        class: "white-space-preline text-body-1 pa-0 pa-sm-4",
                        innerHTML: testo.contenuto
                      }, null, 8, ["innerHTML"]))
                    }), 256))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 256))
    ]),
    _: 1
  }))
}